// extracted by mini-css-extract-plugin
export default {"container":"Kba-z","heading":"Lba-z","links":"Mba-z","linkBtn":"Nba-z","disabled":"Oba-z","linkUppercaseBold":"Pba-z","copy":"Qba-z","subCopy":"Rba-z"};